import { useMutation } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';
import { useToast } from 'components/hooks/useToast';

import { TOAST_STATUSES } from 'constants/ProjectConstants';
import { endpoints } from 'constants/endpoints';

import { rowData } from '../slice/CheckInIntentSlice';

const bulkCheckInAPI = async (editedRows: rowData[]) => {
  const body = editedRows.map(({ progressLevel, closureStatus, achieved, commentPayloadType, uuid, title }) => ({
    goalId: uuid,
    title,
    actual: achieved,
    goalProgressLevel: progressLevel,
    goalClosureStatus: closureStatus,
    comment: commentPayloadType,
  }));
  try {
    const url = endpoints.rabbitGoals.bulkCheckIn;
    // @ts-expect-error send request is not typed
    const res = await sendRequest({
      url,
      method: 'POST',
      credentials: 'include',
      body,
    });
    return res.entity;
  } catch (error) {
    console.error('Error while fetching data ', error);
    throw new Error(error);
  }
};

export const useBulkCheckIn = (refetchHandler: () => void, onErrorCallback: (err: { message: string }) => void) => {
  const toast = useToast();

  return useMutation({
    mutationFn: (editedRows: rowData[]) => bulkCheckInAPI(editedRows),

    onError: (err: { message: string }) => {
      if (typeof onErrorCallback === 'function') {
        onErrorCallback(err);
      }
      toast({
        title: err?.message || 'Error while checking in goals. Please try again.',
        status: TOAST_STATUSES.ERROR,
        position: 'bottom-left',
      });
    },
    onSuccess: () => {
      if (typeof refetchHandler === 'function') {
        refetchHandler();
      }
    },
  });
};
